import { render, staticRenderFns } from "./InvoicePlan.vue?vue&type=template&id=504a1e9c"
import script from "./InvoicePlan.vue?vue&type=script&lang=js"
export * from "./InvoicePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports